module.exports = __webpack_public_path__ + "static/media/chair-busy.4703d1eb.png";